import * as React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {CircularProgress, WithStyles} from "@material-ui/core";
import {LoadingStyles} from "@components/onboarding/steps/StepLoading/loading.styles";

class StepLoading extends React.Component<WithStyles<typeof LoadingStyles>> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        const style = this.props.classes;

        return (
            <div className={style.root}>
                <div className={style.background}>
                    <div className={style.circle}/>
                </div>
                <div className={style.container}>
                    <div className={style.middleContent}>
                        <CircularProgress variant="indeterminate" size="7rem"/>
                    </div>

                </div>
            </div>
        );
    }
}

export default withStyles(LoadingStyles)(StepLoading);



// WEBPACK FOOTER //
// ./src/components/onboarding/steps/StepLoading/loading.component.tsx